import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PropertyTypeRequestBody, PropertyTypeResponse } from "./types";

export class PropertyTypeAPI extends BaseAPI<
    PropertyTypeRequestBody,
    PropertyTypeResponse
> {
    protected route = ApiRoutes.search.property_type;
    protected method = RequestMethod.GET;
    protected params = ["str:category_type"];
}

export class PropertyTypesAPI extends BaseAPI<
    PropertyTypeRequestBody,
    PropertyTypeResponse
> {
    protected route = ApiRoutes.search.property_types;
    protected method = RequestMethod.GET;
} 